import React from 'react';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { AddInternalProcurementType } from 'models/procurement.model';
import useDashboardContext from 'contexts/dashboard.context';
import useTransferContext from 'contexts/transfer.context/context';

const NewTransferPreview = ({
  formData,
  handleEdit
}: {
  formData: AddInternalProcurementType[];
  handleEdit: () => void;
}) => {
  const { formStoreItems } = useDashboardContext();
  const { transferDetails } = useTransferContext();
  const getIngredient = (id: string) => formStoreItems?.find((ingredient) => ingredient.id === id);

  return (
    <div>
      <div className='flex justify-between mb-16'>
        <div className='space-y-4'>
          <p className='font-medium text-[#2E3031] capitalize '>
            <span className='font-semibold'>Title: </span> {transferDetails.title}
          </p>

          <p>
            <span className='font-semibold'>Note: </span> {transferDetails.note}
          </p>
        </div>
        <div className='space-y-4'>
          <p className=' font-medium text-[#2E3031]'>
            <span className='font-semibold '>Cokitchen: </span>
            {transferDetails.cokitchen.name}
          </p>

          <p className=' font-medium text-[#2E3031]'>
            <span className='font-semibold'>Store: </span>
            {transferDetails.store.name}
          </p>
          <p className=' font-medium text-[#2E3031]'>
            <span className='font-semibold '>Store type: </span>
            {transferDetails.storeType.name}
          </p>
        </div>
      </div>

      <p className='font-semibold mb-4'>Ingredients</p>
      {formData.map((data, index) => (
        <div
          className='flex justify-between border-b border-b-[#EAEBEB] pb-6 gap-6 items-center'
          key={index}>
          <div className='flex items-center gap-2'>
            <p className='font-medium text-[#2E3031] capitalize'>
              {getIngredient(data.ingredient_id)?.name}
            </p>
            <div className='bg-gray-2 rounded-full p-1' />
            <div className='flex gap-2 flex-wrap'>
              <p className='text-sm font-medium text-[#2E3031]'>
                {data.quantity} {getIngredient(data.ingredient_id)?.unit_type}
              </p>
            </div>
          </div>
          <EditIcon onClick={handleEdit} className='cursor-pointer' />
        </div>
      ))}
    </div>
  );
};

export default NewTransferPreview;
